module.exports = __webpack_public_path__ + "img/04.f8ebd679.png";